export function normalizeSeatName(name: string): string {
    if (!name) return name;
    const n = String(name).toLowerCase();
    if (
        n.includes('universal back bench') ||
        n.includes('back bench') ||
        n.includes('rear bench') ||
        n.includes('rear seats') ||
        n.includes('rear seat')
    ) {
        return 'Rear Seats';
    }
    return name;
}

export function normalizeAvailability(
    avail?: Record<string, any>
): Record<string, any> | undefined {
    if (!avail) return avail;
    const out: Record<string, any> = {};
    for (const [seat, val] of Object.entries(avail)) {
        const key = normalizeSeatName(seat);
        if (!out[key]) {
            out[key] = val;
        } else {
            const existing = out[key];
            if (existing && typeof existing === 'object' && val && typeof val === 'object') {
                out[key] = { ...existing, ...val };
            } else {
                out[key] = val;
            }
        }
    }
    return out;
}

export function buildBiz2Coverages(
    availability: Record<string, any> | null | undefined
): Record<string, Record<string, { variant_id: number | null; available: boolean }>> | null {
    if (!availability) return null;
    const coverages: Record<string, Record<string, { variant_id: number | null; available: boolean }>> = {};
    const normalized = normalizeAvailability(availability) ?? {};
    for (const [seat, seatData] of Object.entries(normalized)) {
        coverages[seat] = {};
        const prekit = Array.isArray(seatData.prekit) ? {} : (seatData.prekit ?? {});
        for (const [color, entry] of Object.entries(prekit)) {
            coverages[seat][color] = {
                variant_id: (entry as any)?.id ?? null,
                available: seatData[color] === true,
            };
        }
    }
    return coverages;
}

